module.exports = __webpack_public_path__ + "static/media/done.de433cd7.svg";